export const environment = {
    production: true,
    api_host: "https://clicyretira.ubq.cl",
    socket_url: 'https://socketserver.pickupwm.ubq.cl',
};
